import { render } from "./mobile-chart.vue?vue&type=template&id=0f512052"
import script from "./mobile-chart.vue?vue&type=script&lang=js"
export * from "./mobile-chart.vue?vue&type=script&lang=js"

import "./mobile-chart.vue?vue&type=style&index=0&id=0f512052&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__